import type { ColorPalette } from '../ColorPalette';
import { AbstractMode } from './AbstractMode';

/**
 * Fixed palette mode (appearance preset: static).
 */
export class StaticColorMode extends AbstractMode {
	constructor(private readonly colorPalette: ColorPalette) {
		super();
	}

	currentPalette(): ColorPalette {
		return this.colorPalette;
	}

	type(): string {
		return 'static';
	}
}
